import React from 'react';
import './App.css';
import GuessSeason from './components/GuessSeason';

function App() {
  return (
    <div className="App">
      <GuessSeason />
    </div>
  );
}

export default App;
